module.exports = __webpack_public_path__ + "assets/certificate_pdf/MS Programming in c-Sharp_Exam 483_F063-2649.c6b76373.pdf";